import React, { useEffect } from 'react';
import {
  FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaMobileAlt, FaAnchor
} from 'react-icons/fa';
import anime from 'animejs';

const Contact = () => {
  useEffect(() => {
    const tl = anime.timeline({
      easing: 'easeOutExpo',
    });

   
    tl.add({
      targets: '.header-reveal',
      opacity: [0, 1],
      translateY: [40, 0],
      duration: 1000,
    })
   
    .add({
      targets: '.contact-card',
      opacity: [0, 1],
      scale: [0.97, 1],
      translateY: [30, 0],
      duration: 800,
      delay: anime.stagger(120, { start: 200 }) 
    }, '-=600'); 
  }, []);

  const googleMapsUrl = "https://www.google.com/maps?ll=41.046173,29.007276&z=16&t=m&hl=tr&gl=TR&mapclient=embed&q=Barbaros+Blv.+No:49+Cihann%C3%BCma+34353+Be%C5%9Fikta%C5%9F/%C4%B0stanbul";

  return (
    <div className="bg-[#fdfcfb] min-h-screen font-sans selection:bg-[#c4a47c] selection:text-white">

      {/* Hero / Header Section */}
      <section className="relative py-32 md:py-40 bg-[#0a111f] overflow-hidden">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-500/5 rounded-full blur-[120px] pointer-events-none"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#c4a47c]/5 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="absolute inset-0 opacity-[0.03] flex items-center justify-center pointer-events-none">
          <FaPhoneAlt size={200} className="text-white -rotate-12 translate-y-10" />
        </div>

        <div className="max-w-7xl mx-auto px-8 relative z-10 text-center header-reveal">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="h-[1px] w-12 bg-[#c4a47c]"></div>
            <FaAnchor className="text-[#c4a47c] text-sm" />
            <div className="h-[1px] w-12 bg-[#c4a47c]"></div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white uppercase italic tracking-tighter leading-none mb-4">
            Get In <span className="text-[#c4a47c]">Touch</span>
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-8 -mt-16 relative z-20 pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12">

          {/* Address Card */}
          <div className="lg:col-span-5 contact-card">
            <article className="bg-white p-10 md:p-12 rounded-[3rem] shadow-[0_40px_100px_rgba(0,0,0,0.04)] border border-[#f0e6d6] h-full transition-all hover:border-[#c4a47c]/30">
              <div className="flex items-center space-x-3 mb-10 border-b border-[#f0e6d6] pb-6">
                <FaMapMarkerAlt className="text-[#c4a47c]" />
                <h3 className="text-sm font-black uppercase tracking-widest text-[#0a111f] italic">Address</h3>
              </div>

              <div className="space-y-10">
                <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" className="block group/address">
                  <h2 className="text-2xl md:text-3xl font-black text-[#c4a47c] uppercase tracking-tighter mb-4 italic leading-[1.1] break-words">
                    Armar<span className="text-[#0a111f]"> Gemi Acenteliği Hizmetleri<br /> Sanayi Ticaret Ltd. Şti.</span>
                  </h2>
                  <address className="not-italic text-slate-500 font-bold text-[15px] md:text-[17px] leading-relaxed border-l-4 border-[#c4a47c] pl-6 uppercase tracking-wider group-hover/address:border-[#0a111f] transition-colors">
                    Barbaros Bulvarı Gürel Apt. No: 49/10 <br />
                    Floor: 6 34022 Beşiktaş / Istanbul, Turkey
                  </address>
                </a>

                <div className="pt-4">
                  <div className="h-[280px] w-full rounded-[2.5rem] overflow-hidden border border-[#f0e6d6] grayscale hover:grayscale-0 transition-all duration-1000 shadow-inner">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3008.961603953736!2d29.00481147656961!3d41.04797041700688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab7a389f46f3d%3A0xc397b91d293f0b24!2sCihannuma%2C%20Barbaros%20Blv.%20No%3A49%2C%2034353%20Be%C5%9Fikta%C5%9F%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      title="Armar Shipping Location"
                    />
                  </div>
                </div>
              </div>
            </article>
          </div>

          {/* Right Side Grid */}
          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 h-[700px] gap-6">

            {/* Office Line */}
            <a href="tel:+902122588002" className="contact-card bg-white p-8 rounded-[2.5rem] border border-[#f0e6d6] shadow-sm hover:border-[#c4a47c] hover:shadow-xl transition-all duration-500 group">
              <div className="w-12 h-12 rounded-2xl bg-slate-50 flex items-center justify-center text-[#c4a47c] mb-6 group-hover:bg-[#c4a47c] group-hover:text-white transition-all">
                <FaPhoneAlt />
              </div>
              <span className="block text-[10px] font-black text-[#9e8d71] uppercase tracking-[0.3em] mb-2">Office Line</span>
              <span className="text-xl font-black text-[#0a111f] group-hover:text-[#c4a47c] transition-colors italic uppercase">+90 212 258 80 02</span>
            </a>

            {/* Direct Cell */}
            <a href="tel:+905454005050" className="contact-card bg-white p-8 rounded-[2.5rem] border border-[#f0e6d6] shadow-sm hover:border-[#c4a47c] hover:shadow-xl transition-all duration-500 group">
              <div className="w-12 h-12 rounded-2xl bg-slate-50 flex items-center justify-center text-[#c4a47c] mb-6 group-hover:bg-[#c4a47c] group-hover:text-white transition-all">
                <FaMobileAlt />
              </div>
              <span className="block text-[10px] font-black text-[#9e8d71] uppercase tracking-[0.3em] mb-2">Direct Cell</span>
              <span className="text-xl font-black text-[#0a111f] group-hover:text-[#c4a47c] transition-colors italic uppercase">+90 545 400 50 50</span>
            </a>

            

            <a href="mailto:armar@armarship.com" className="contact-card md:col-span-2 bg-[#0a111f] p-8 md:p-10 rounded-[2.5rem] shadow-2xl flex items-center justify-between group overflow-hidden relative border border-transparent hover:border-[#c4a47c]/40 transition-all duration-500">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#c4a47c]/10 blur-3xl rounded-full"></div>
              <div className="flex items-center space-x-6 relative z-10 min-w-0">
                <div className="p-4 bg-white/5 rounded-2xl border border-white/10 text-[#c4a47c] group-hover:bg-[#c4a47c] group-hover:text-white transition-all duration-500 shrink-0">
                  <FaEnvelope size={28} />
                </div>
                <div className="min-w-0">
                  <span className="block text-[10px] font-black text-[#c4a47c]/60 uppercase tracking-[0.3em] mb-1">Email</span>
                  <span className="text-xl font-black text-white group-hover:text-[#c4a47c] transition-colors duration-500 italic tracking-wide break-all block">
                  armar@armarship.com
                  </span>
                </div>
              </div>
              <FaAnchor className="text-white/5 text-5xl hidden md:block relative z-10 group-hover:text-[#c4a47c]/20 transition-all duration-700" />
            </a>

          </div>
        </div>
      </div>

      <div className="h-2 bg-gradient-to-r from-[#0a111f] via-[#c4a47c] to-[#0a111f]"></div>
    </div>
  );
};

export default Contact;